import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdatePaymentAccountsListRequestModel, UpdatePaymentAccountsListResponseModel } from "@/features/accounts/payment/scraping/services/update-accounts-list-model";
import { Timeout } from "@/shared/services/http-client";

export class UpdatePaymentAccountsListApi {
  /**
   * MoneyLook 口座更新API(スクレイピング)
   */
  public updatePaymentAccountsList = async (
    param: UpdatePaymentAccountsListRequestModel
  ): Promise<UpdatePaymentAccountsListResponseModel> => {
    const path = `/api/paymentaccounts/scraping/updateaccounts`;
    const res = await ApiClient.instance.post<UpdatePaymentAccountsListResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
      timeout: Timeout.VeryLong,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
